export default __webpack_public_path__ + "static/char-v-03-cee927a9edf3f9ba029a507ee4277e8f.webp";